import * as Yup from "yup";

const flattenFields = (arr) => {
  const result = [];

  function traverse(fields, groupPath = "") {
    fields.forEach((field) => {
      let path = groupPath ? `${groupPath}.${field.id}` : field.id;
      if (field.nested !== "group") {
        result.push({ ...field, path });
      }

      if (field.nested === "group") {
        traverse(field.subfields, path);
      }
    });
  }

  traverse(arr);
  return result;
};

const validateField = (field, required = true) => {
  let fieldSchema;
  switch (field.type) {
    case "array":
      if (required) {
        fieldSchema = Yup.array().of(Yup.string().required(field.errormsg));
      } else {
        fieldSchema = Yup.array().of(Yup.string().nullable().notRequired());
      }
      break;
    case "choiceList":
      if (required || field.min || field.max) {
        fieldSchema = Yup.array().of(Yup.string());

        if (field.min !== undefined) {
          fieldSchema = fieldSchema.min(field.min, "Select minimum " + field.min);
        }

        if (field.max !== undefined) {
          fieldSchema = fieldSchema.max(field.max, "Select maximum " + field.max);
        }
      } else {
        fieldSchema = Yup.array().of(Yup.string()).nullable().notRequired();
      }
      break;
    case "email":
      if (required) {
        fieldSchema = Yup.string().email("Invalid email").required(field.errormsg);
      } else {
        fieldSchema = Yup.string().email("Invalid email").nullable();
      }
      break;
    case "number":
      if (required) {
        fieldSchema = Yup.number().required(field.errormsg);
      } else {
        fieldSchema = Yup.number().nullable();
      }
      break;
    case "video":
      fieldSchema = fieldSchema.nullable().notRequired();
      break;
    case "tel":
      if (required) {
        fieldSchema = Yup.string()
          .matches(/^\d{10}$/, "Invalid Mobile Number") // Ensures exactly 10 digits
          .required(field.errormsg);
      } else {
        fieldSchema = Yup.string()
          .matches(/^\d{10}$/, "Invalid Mobile Number") // Ensures exactly 10 digits
          .nullable();
      }
      break;
    default:
      if (required) {
        fieldSchema = Yup.string().required(field.errormsg);
      } else {
        fieldSchema = Yup.string().nullable();
      }
  }
  return fieldSchema;
};

const CreateValidationSchema = (formFields) => {
  let flattenFiled = flattenFields(formFields);

  const schema = flattenFiled.reduce((acc, field) => {
    let fieldSchema;
    if (!field.nested && field.validated && field.type !== "video" && field.type !== "fileUpload") {
      if (field.dependOn) {
        fieldSchema = Yup.string().when(field.dependOn.name, {
          is: field.dependOn.value,
          then: () => validateField(field),
          otherwise: () => validateField(field, false),
        });
      } else {
        fieldSchema = validateField(field);
      }
    }

    if (field.nested === "array") {
      const subfieldsSchema = CreateValidationSchema(field.subfields);
      fieldSchema = Yup.array().of(subfieldsSchema);
    } else if (field.nested === "object") {
      const subfieldsSchema = CreateValidationSchema(field.subfields);
      fieldSchema = subfieldsSchema;
    } else if (field.nested === "group") {
      let filed = flattenFields(field.subfields);
      const subfieldsSchema = CreateValidationSchema(filed);
      fieldSchema = subfieldsSchema;
    }

    if (field.nested !== "group") {
      return { ...acc, [field.name]: fieldSchema };
    } else {
      return fieldSchema.fields;
    }
  }, {});
  return Yup.object().shape(schema);
};

export default CreateValidationSchema;

// const field = {
//   id: "title1",
//   name: "title1",
//   label: "Title1",
//   validated: true,
//   type: "text",
//   depenOn: {
//     name: "select",
//     value: "yesterday",
//   },
//   errormsg: "Title1 is required",
// };

// // Define the validation schema
// const validationSchema = Yup.object().shape({
//   [field.name]: Yup.string().when(field.depenOn.name, {
//     is: (val) => val == field.depenOn.value,
//     then: (schema) => schema.required(field.errormsg),
//   }),
// });

// // Usage example
// const data = {
//   title1: "sss",
//   select: "yesterday",
// };

// // Validate the data
// validationSchema
//   .validate(data)
//   .then((validatedData) => {
//     console.log("Data is valid:", validatedData);
//   })
//   .catch((error) => {
//     console.log("Validation error:", error);
//   });
